/**
 * Overrides the behavior of the `parquet-wasm` package to load `parquet_wasm_bg.wasm` without conditions.
 *
 * **Issue**: `loadWasm` in `@loaders.gl/parquet/dist/index.cjs` doesn't load the `.wasm` file due to some issues in the current `webpack` configuration. The Kepler.gl team uses `esbuild` bundler, and there isn't such an issue.
 * Previously, they used webpack as well, but there wasn't a `.parquet` upload at that time, therefore, there wasn't a chance to find a proper `webpack` configuration.
 *
 * **Reason**: `parquet_wasm` is imported and wrapped by `__toESM` function in transpiled code. This causes the appearance of `import_parquet_wasm.default.default`.
 * and the condition `typeof import_parquet_wasm.default === "function"` in the `loadWasm` function is never met.
 *
 */

const wasm = require('original-parquet-wasm');

(async function () {
    // PARQUET_WASM_URL in @loaders.gl/parquet/dist/lib/constants
    await wasm.default('https://unpkg.com/parquet-wasm@0.6.1/esm/parquet_wasm_bg.wasm');
}());

module.exports = wasm;
